import { motion } from "framer-motion";
import { useLang, useSeo } from "../i18n/LangContext";
import { PageHeader, FinalCta } from "../components/site/Sections";
import { EASE } from "../config";

const dots = ["#005F60", "#FF682F", "#FFCC00", "#005F60", "#FF682F"];

export default function Method() {
  const { t } = useLang();
  useSeo("method");
  const m = t.methodPage;
  return (
    <>
      <PageHeader eyebrow={m.eyebrow} lines={m.lines} intro={m.intro} testId="method-header" />
      <section className="mx-auto max-w-[1400px] px-6 pb-28 sm:px-10 lg:pb-40" data-testid="method-timeline">
        <motion.ol
          className="relative grid gap-12 pl-10 lg:grid-cols-5 lg:gap-8 lg:pl-0 lg:pt-14"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.1 }}
        >
          <motion.span
            aria-hidden="true"
            className="absolute bottom-0 left-[7px] top-0 w-px origin-top bg-[#121518] lg:bottom-auto lg:left-0 lg:right-0 lg:top-[7px] lg:h-px lg:w-auto lg:origin-left"
            variants={{ hidden: { scale: 0 }, show: { scale: 1, transition: { duration: 1.6, ease: EASE } } }}
          />
          {m.acts.map((a, i) => (
            <motion.li
              key={a.num}
              className="relative"
              data-testid={`method-act-${i + 1}`}
              variants={{ hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: EASE, delay: 0.3 + i * 0.15 } } }}
            >
              <span className="absolute -left-10 top-1 h-[15px] w-[15px] lg:-top-14 lg:left-0" style={{ background: dots[i] }} aria-hidden="true" />
              <p className="text-[11px] uppercase tracking-[0.28em] text-[#4A525A]">{m.act} {a.num}</p>
              <p className="f-serif mt-3 text-6xl italic leading-none text-[#005F60] lg:text-7xl">{a.num}</p>
              <h3 className="f-serif mt-6 text-2xl leading-tight lg:text-[1.65rem]">{a.name}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#2E353B]">{a.text}</p>
            </motion.li>
          ))}
        </motion.ol>
      </section>
      <FinalCta />
    </>
  );
}
